import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from './../../../../../themes/default'
import { TableHead, TableSortLabel } from './../../../../../themes/table';
import Row from './../row';
import Cell from './../cell';

class Thead extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {

    const { rows, order, orderBy } = this.props;

    return (
      <TableHead>
        <Row>
          {rows.map(row => {
            return (
              <Cell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={ orderBy === row.id ? order : false } style={{ width: row.width ? row.width : 'auto', minWidth: row.width ? row.width : 'auto' }}>
                { row.sort ? (
                  <Tooltip
                    title="Ordenar"
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}>
                      <TableSortLabel
                        active={orderBy === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id)}>
                        { row.label }
                      </TableSortLabel>
                  </Tooltip>
                ) : (
                   <strong>{ row.label }</strong>
                )}
              </Cell>
            );
          }, this)}
        </Row>
      </TableHead>
    );

  }
}

Thead.propTypes = {
  //onRequestSort: PropTypes.func.isRequired,
  // order: PropTypes.string.isRequired,
  // orderBy: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired
};

export default Thead;
